import { createContext, useContext, type ReactNode } from "react";
import { useGlobalLedgerEvents } from "../hooks/useLedgerEvents";
import type { LedgerEvent } from "../sse";

const LedgerEventsContext = createContext<LedgerEvent[]>([]);

export function useActivityFeed() {
  return useContext(LedgerEventsContext);
}

export function LedgerEventsProvider({ children }: { children: ReactNode }) {
  const events = useGlobalLedgerEvents();
  return <LedgerEventsContext.Provider value={events}>{children}</LedgerEventsContext.Provider>;
}
